import INotification from "app/models/notification"
import IState from "../state"

export const getNotifications = (state: IState): INotification[] => state.notifications.notifications
